import { render } from "./Post1.vue?vue&type=template&id=ced7b5d8&scoped=true"
import script from "./Post1.vue?vue&type=script&lang=js"
export * from "./Post1.vue?vue&type=script&lang=js"

import "./Post1.vue?vue&type=style&index=0&id=ced7b5d8&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced7b5d8"]])

export default __exports__